/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-23 18:47:49
 */

 import * as Vue from 'vue-tsx-support';
 import { Component, Prop } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import Modal from 'src/types/iview/Modal';
 import Button from 'src/types/iview/Button';
 import Input from 'src/types/iview/Input';
 import { Toast } from 'src/util/toast';
 import { modalFactory } from 'src/util/vueExtend';
 import EnumOperates from 'src/enums/enumOperates';
 import { Integer } from 'src/types/base';
 import EntitySelect from 'src/components/SelectCustom/entitySelect';
 import EnumEntity from 'src/enums/enumEntity';
 import InputNumber from 'src/types/iview/InputNumber';
//  import DeclareMaintenanceApi, { DeclareMaintenanceDOI } from './api/declareMaintenanceApi';
import MnManageApi, {MnManageDOI} from './api/mnmanageApi'
 import { createNamespace } from 'src/util/bem';
 import EnumMaintenanceAuditStatus from 'src/enums/enumMaintenanceAuditStatus';
 import { DateTimeUtil } from 'src/util/dateTimeUtil';
 import  DatePicker from 'src/types/iview/DatePicker';
 import EnumAlarmType from 'src/enums/enumAlarmType';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';

export namespace MnManageVOI {
    export interface PropsI {
        operate: string;
        id?: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        mn: string;
        id: Integer;
        company_unit: Integer;
    }
}

let uid = 1;

@Component
class MnManageModal extends Vue.Component<MnManageVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: MnManageVOI.FormDataI = {
        mn: '',
        company_unit: '',
        id:null,
    };
    rules: any = {};

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        let res;
        this.loading = true;
        this.formData.timestamp = DateTimeUtil.getSecondFromIviewDate(this.formData.timestamp)
        let params: MnManageDOI.FormDataI = {
            ...this.formData,
        };
        switch (this.operate) {
            case EnumOperates.Add.getName():
                res = await MnManageApi.add(params);
                break;
            case EnumOperates.Update.getName():
                params.id = this.id;
                res = await MnManageApi.update(params);
                break;
        }
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success('成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
    genKey() {
        return uid++;
    }
    add(index: number) {
        this.formData.operationalSite.splice(index + 1, 0, { deviceId: null, components: [], key: this.genKey() });
    }
    sub(index: number) {
        this.formData.operationalSite.splice(index, 1);
    }
    async mounted() {
        if (this.operate !== EnumOperates.Add.getName()) {
            let { code, data } = await MnManageApi.searchDetail(this.id);
            debugger
            if (code === 0) {
                this.formData = {
                    ...data,
                };
            }
        }
    }
    render(h) {
        return (
            <Modal title={this.operate+"mn管控"} width="800" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item v-if={this.operate == EnumOperates.Add.getName()} label="mn号" prop="mn" style="display: inline-block;width:45%">
                        <Input  placeholder="请输入" v-model={this.formData.mn} />
                    </form-item>
                    <form-item v-if={this.operate == EnumOperates.Update.getName()} label="mn号" prop="mn" style="display: inline-block;width:45%">
                        <Input disabled placeholder="请输入" v-model={this.formData.mn} />
                    </form-item>
                    <form-item label="所属单位" prop="company_unit" style="display: inline-block;width:45%">
                        <Input  placeholder="请输入" v-model={this.formData.company_unit} />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertMnManageModal(operate: string, id?: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<MnManageVOI.PropsI>(MnManageModal)({
            id,
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}